export default __webpack_public_path__ + "static/media/cp_surge.5c211881.pdf";